<!--
   Created by qing on 2020/12/22
   Des: 
-->
<template>

  <van-popup
    class="mix-form-edit-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">

    <template v-if="mixFormInfo">

      <div style="margin-top: 10px">
        <van-field
          v-model="mixFormInfo.mixFormName"
          name="名称"
          label="名称"
          :rules="[{ required: true, message: '请填写名称' }]"
        />

        <van-field
          readonly
          clickable
          name="picker"
          label="分组"
          placeholder="点击选择分组"
          @click="showSheet = true">
          <template #input>
            <div style="text-align: left;">
              {{groupNames}}
            </div>
          </template>
        </van-field>

        <van-action-sheet
          v-if="actions.length"
          v-model="showSheet"
          title="选择分组"
          :actions="actions"
          cancel-text="完成"
          @select="onSelect"
        />
        <van-action-sheet
          v-else
          title="选择分组"
          v-model="showSheet">
          <div style="width: 100%; height: 200px; display: flex; align-items: center; justify-content: center">暂无分组</div>
        </van-action-sheet>
      </div>
      <van-field label="负责人" style="margin-top: 10px">
        <template #input>
          <ContactBox
            :field="chargeUserConfig"
            :user-id="$store.state.userId"
            :company-id="$store.state.companyId"
            :multiple="false"
            :hasDep="false"
            :hasRole="false"
            :has-ext="false"
            :has-label="false"
            :selectedMember="selectChargeUser"
            :selectedExt="selectChargeUser"
            @change="chargeUserChange"
            @selectedComplete="chargeUserChange">
          </ContactBox>
        </template>
      </van-field>
      <van-field label="参与人" style="margin-top: 10px">
        <template #input>
          <ContactBox
            :field="participantConfig"
            :user-id="$store.state.userId"
            :company-id="$store.state.companyId"
            multiple
            :selectedMember="mixFormInfo.participant.member"
            :selectedDep="mixFormInfo.participant.depart"
            :selectedRole="mixFormInfo.participant.role"
            :selectedExt="mixFormInfo.participant.external"
            :selectedLabel="mixFormInfo.participant.externalTag"
            @selectedComplete="selectedParticipantComplete">
          </ContactBox>
        </template>
      </van-field>

      <div class="footer">
        <van-button
          @click="cancel">
          取 消
        </van-button>
        <van-button
          type="primary"
          @click="submitData">
          确定
        </van-button>
      </div>
    </template>
  </van-popup>
</template>

<script>
  import {clone} from "../../../assets/js/Untis"

  export default {
    props: {
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      },
      groupList: {
        type: Array,
        default: () => []
      },
      chargeUserConfig: Object,
      participantConfig: Object
    },
    data() {
      return {
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        showSheet: false,
        mixFormInfo: null,

      }
    },
    created() {
    },
    computed: {

      actions() {
        return this.groupList.map(group => {
          return {
            name: group.groupName,
            ...group
          }
        })
      },
      selectChargeUser: {
        set(val) {
          this.mixFormInfo.chargeUser = val[0]
        },
        get() {
          if (this.mixFormInfo.chargeUser) {
            return [this.mixFormInfo.chargeUser]
          } else {
            return []
          }
        }
      },
      groupNames() {
        return this.groupList.filter(group => this.mixFormInfo.groupIdList.includes(group.groupId))
          .map(group => group.groupName)
          .filter(item => !!item)
          .join('、')
      },
    },
    methods: {
      open({mixFormInfo, groupId}) {
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
        if (mixFormInfo) {
          this.mixFormInfo = clone(mixFormInfo)
        } else {
          const groupIdList = groupId && !['', 'ALL', 'CREATE_BY_ME', 'SHARE_TO_ME'].includes(groupId) ? [groupId] : []

          this.mixFormInfo = {
            mixFormName: '',
            groupIdList,
            chargeUser: this.$store.getters.userId,
            top: 0,
            participant: {
              depart: [],
              member: [],
              role: [],
              external: [],
              externalTag: []
            },
            processType: 'NODE'
          }
        }
      },

      beforeClose() {
        this.$emit('close')
      },
      onSelect(opt) {
        if (this.mixFormInfo.groupIdList.includes(opt.groupId)) {
          this.mixFormInfo.groupIdList.splice(this.mixFormInfo.groupIdList.indexOf(opt.groupId), 1)
        } else {
          this.mixFormInfo.groupIdList.push(opt.groupId)
        }
      },
      chargeUserChange(selected) {
        // change方法返回的是member， complete方法返回的是memberIds
        if (selected) {
          if (selected.hasOwnProperty('memberIds') && selected.memberIds.length) {
            this.mixFormInfo.chargeUser = selected.memberIds[0]
          } else if(selected.hasOwnProperty('extIds') && selected.extIds.length) {
            this.mixFormInfo.chargeUser = selected.extIds[0]
          } else {
            this.mixFormInfo.chargeUser = selected.member[0]
          }
        }
      },
      selectedParticipantComplete(selected) {
        if (selected) {
          this.mixFormInfo.participant.member = selected.memberIds
          this.mixFormInfo.participant.depart = selected.depIds
          this.mixFormInfo.participant.role = selected.roleIds
          this.mixFormInfo.participant.external = selected.extIds
          this.mixFormInfo.participant.externalTag = selected.labelIds
        }
      },
      cancel() {
        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
      },
      submitData() {
        if (!this.mixFormInfo.mixFormName) {
          this.$toast.fail('名称不能为空')
          return
        }
        if (!this.mixFormInfo.chargeUser) {
          this.$toast.fail('负责人不能为空')
          return
        }
        const toast = this.$toast.loading('加载中...')
        if (this.mixFormInfo.mixFormId) {
          this.$store.dispatch('actionMixFormUpdate', this.mixFormInfo)
            .then(res => {
              this.$toast.success('更新成功')
              this.$emit('updateMixFormSuccess')
              this.cancel()
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        } else {
          this.$store.dispatch('actionMixFormCreate', this.mixFormInfo)
            .then(res => {
              this.$toast.success('创建成功')
              this.$emit('createMixFormSuccess', res.mixFormId)
              this.cancel()
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }

      }
    }
  }
</script>

<style lang="less">

  .mix-form-edit-popup {
    background-color: #F6F6F6 !important;

    .van-field__label {
      width: 60px;
      font-size: 13px;
    }

    .van-field__value {
      font-size: 13px;
    }

    .footer {
      background-color: #fff;
      position: absolute;
      bottom: calc(env(safe-area-inset-bottom));
      left: 0;
      right: 0;
      height: 44px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .van-button {
        width: 50%;
        border-radius: 0;
      }
    }
  }
</style>